import * as React from 'react';

import DeliveryMethodsTable from './ProductTagTable';
import { RouteComponentProps } from 'react-router';

interface IDeliveryMethodsProps extends RouteComponentProps<{ 
    eshop: string;
    productTagId: string;
}> {
    
}

export default class DeliveryMethods extends React.Component<IDeliveryMethodsProps> {

    render() {
        return (
            <div>
                <DeliveryMethodsTable
                    domain={this.props.match.params.eshop}
                    productTagId={this.props.match.params.productTagId}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/ProductTag/index.tsx